export default __webpack_public_path__ + "static/media/alert-circle.3870bde0.svg";